export function bioReducer (state = {bio: [], error: null}, action) {
  switch (action.type) {
    case 'LOAD_BIO_START':
      return {
        ...state,
        error: null
      }
    case 'LOAD_BIO_SUCCESS':
      return {
        ...state,
        bio: action.payload
      }
    case 'LOAD_BIO_ERROR':
      return {
        ...state,
        error: action.payload,
        bio: []
      }
    default:
      return state;
  }
}

export default bioReducer;



// WEBPACK FOOTER //
// ./src/reducers/bio.js